import React, { useEffect, useState } from 'react';
import pt_BR from 'date-fns/locale/pt-BR';

import { isAfter, differenceInDays, format } from 'date-fns';

import Modal from '@material-ui/core/Modal';
import ButtonBase from '@material-ui/core/ButtonBase';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

import { RiErrorWarningFill } from 'react-icons/ri';
import WarningIcon from '@material-ui/icons/Warning';
import CloseIcon from '@material-ui/icons/Close';

import { useAuth } from '../../../hooks/auth';

import { Container, Header, Body } from './styles';
import stylesMaterial from './stylesMaterial';

interface LicenseModalProps {
  handleCloseLicenseModal: () => void;
  openLicenseModal: boolean;
}

const LicenseModal: React.FC<LicenseModalProps> = ({
  handleCloseLicenseModal,
  openLicenseModal,
}) => {
  const classes = stylesMaterial();
  const { user } = useAuth();
  const [open, setOpen] = React.useState(openLicenseModal);
  const [tempDataExp, setTempDataExp] = useState(new Date());

  useEffect(() => {
    setTempDataExp(
      user.data_expiracao ? new Date(user.data_expiracao) : new Date(),
    );
  }, []);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    handleCloseLicenseModal();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      id="modal"
      className={classes.modal}
    >
      <Container>
        <Header>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            className={classes.buttonClose}
          >
            <CloseIcon className={classes.iconClose} />
          </IconButton>
        </Header>
        <Body>
          {isAfter(new Date(tempDataExp), new Date()) ? (
            <span
              style={{ color: '#FF8946', fontSize: '50px' }}
              className="material-icons"
            >
              warning
            </span>
          ) : (
            <span
              style={{ color: '#F64444', fontSize: '50px' }}
              className="material-icons"
            >
              new_releases
            </span>
          )}
          <Typography className={classes.licenseTimeText}>
            {isAfter(new Date(tempDataExp), new Date())
              ? `Restam ${differenceInDays(
                  new Date(tempDataExp),
                  new Date(),
                )} ${
                  differenceInDays(new Date(tempDataExp), new Date()) > 1
                    ? 'dias'
                    : 'dia'
                }`
              : 'Sua licença expirou'}
          </Typography>
          <Typography className={classes.bodyText}>
            {isAfter(new Date(tempDataExp), new Date()) ? (
              <>
                A sua loja online vai ficar indisponível em
                <strong>
                  {' '}
                  {format(new Date(tempDataExp), "dd' de 'MMMM' de 'yyyy", {
                    locale: pt_BR,
                  })}
                </strong>
                . Entre em contato com o revendedor da sua região para renovar
                sua licença.
              </>
            ) : (
              <>
                A sua loja online não está disponível. Entre em contato com o
                revendedor da sua região para renovar sua licença.
              </>
            )}
          </Typography>
          <ButtonBase onClick={handleClose} className={classes.supportButton}>
            <Typography className={classes.supportButtonText}>OK</Typography>
          </ButtonBase>
        </Body>
      </Container>
    </Modal>
  );
};

export default LicenseModal;
